import {Organisation} from "./Organisation.js";
import {OrganisationType} from "./OrganisationType.js";

export class OrganisationBuilder {

    /**
     * organisation {Organisation}
     */
    organisation;

    constructor() {
        this.organisation = new Organisation();
    }

    /**
     * @param value {string}
     * @returns {OrganisationBuilder}
     */
    setName(value) {
        this.organisation.name = value;
        return this;
    }

    /**
     * @param value {OrganisationType}
     * @returns {OrganisationBuilder}
     */
    setEntityType(value) {
        this.organisation.entityType = value;
        return this;
    }

    /**
     * @param value {string}
     * @returns {OrganisationBuilder}
     */
    setNumber(value) {
        this.organisation.number = value;
        return this;
    }

    /**
     * @param value {string}
     * @returns {OrganisationBuilder}
     */
    setVatId(value) {
        this.organisation.vatId = value;
        return this;
    }
}